import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { QueryBuilder } from '@common/model/query-builder.model';
import { environment } from '@environments/environment';
import { Observable, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ReadService {
  protected resourceUrl = `${environment.SERVER_READ_API_URL}/api/read`;
  protected habilitationUrl = `${environment.SERVER_UTILISATEUR_API_URL}/api/habilitation`;

  constructor(protected http: HttpClient) {}

  query(
    name: string,
    option: QueryBuilder = { params: {} }
  ): Observable<any> {
    return this.http.post<any>(
      `${this.resourceUrl}/${name}`,
      option,
      { observe: 'body' }
    );
  }

  exportTable(
    name: string,
    option: QueryBuilder = { params: {} }
  ): Observable<any> {
    return this.http.request('POST',
      `${this.resourceUrl}/export-table/${name}`,
      {body:option,  observe: 'response', responseType: 'blob' }
    );
  }

  exportGrouped(
    name: string,
    groupColumns: number,
    option: QueryBuilder = { params: {} }
  ): Observable<any> {
    return this.http.request('POST',
      `${this.resourceUrl}/export-grouped/${name}`,
      {body:option, params: { groupColumns }, observe: 'response', responseType: 'blob' }
    );
  }

  queryPaged(name: string, option: QueryBuilder): Observable<any> {
    return this.http
      .post<any>(`${this.resourceUrl}/${name}/paged`, option, {
        observe: 'body',
      })
  }

  queryResult(
    name: string,
    option: QueryBuilder = { params: {} }
  ): Observable<any> {
    return this.query(name, option).pipe(
      map((res: any) => res ?? [])
    );
  }

  queryHabilitation(habilitation: string, value: any=''): Observable<any> {
    return this.http
      .get<any>(`${this.habilitationUrl}/${habilitation}/${value}`, {
        observe: 'body',
      })
      .pipe(map((res: any) => res ?? []));
  }

  queryRef(code: String): Observable<any> {
    return this.queryResult('Referentiel', { params: { code } });
  }

  queryOne(name: string, option: QueryBuilder): Observable<any> {
    return this.http
      .post<any>(`${this.resourceUrl}/${name}`, option, {
        observe: 'body',
      })
      .pipe(
        map((result: any) => {
          let data = undefined;
          if (result?.length) {
            data = result[0];
          }
          return data;
        })
      );
  }
}
